var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-indigo-600 px-16 py-12"},[_c('div',{staticClass:"max-w-5xl mx-auto space-y-8"},[_c('div',{staticClass:"flex -mx-4"},[_c('div',{staticClass:"w-1/4 px-4"},[_vm._t("default")],2),_c('div',{staticClass:"flex-1 px-4"},[_c('h3',{staticClass:"text-white"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }